import { render } from "./CopyAlarmcodeSystem.vue?vue&type=template&id=5a2564da"
import script from "./CopyAlarmcodeSystem.vue?vue&type=script&lang=js"
export * from "./CopyAlarmcodeSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__